import { Component, computed, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ProgressSpinner } from 'primeng/progressspinner';
import { Toast } from 'primeng/toast';
import { environment } from '../environments/environment';
import { AuthStore } from './auth/services/auth.store';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, Toast, ProgressSpinner],
  template: `
    <p-toast position="top-right"></p-toast>
    @if (showBootstrapLoader()) {
      <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-50 px-4 dark:bg-slate-950">
        <div
          class="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 text-center text-slate-900 shadow-xl dark:border-slate-800 dark:bg-slate-900 dark:text-slate-50"
        >
          <div class="flex justify-center">
            <p-progressSpinner strokeWidth="3" styleClass="w-20 h-20" />
          </div>
          <div class="mt-6">
            <div class="text-xl font-semibold tracking-tight">Ładujemy aplikację</div>
            <p class="mt-2 text-sm text-slate-600 dark:text-slate-300">
              Sprawdzamy Twoją sesję i dane użytkownika.
            </p>
          </div>
        </div>
      </div>
    } @else {
      <router-outlet></router-outlet>
    }
  `,
})
export class AppComponent implements OnInit {
  private readonly titleService = inject(Title);
  private readonly authStore = inject(AuthStore);

  readonly showBootstrapLoader = computed(() => this.authStore.loading());

  constructor() {
    if (this.authStore.isLoggedIn()) {
      this.authStore.loadUser(true);
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle(environment.title);
  }
}
